import { initializeApp, getApps, getApp, FirebaseApp } from 'firebase/app';
import { initializeFirestore } from 'firebase/firestore';
import { environment } from '../../environments/environment';

let app: FirebaseApp;

export function getFirebaseApp(): FirebaseApp {
  if (!getApps().length) {
    app = initializeApp(environment.firebase);
    // Fall back from WebChannel/QUIC to long-polling when the transport is
    // unhealthy — the shared backend is known to hit QUIC_NETWORK_IDLE_TIMEOUT
    // storms that make reads fail silently (same fix as the build app).
    initializeFirestore(app, { experimentalAutoDetectLongPolling: true });
  } else {
    app = getApp();
  }
  return app;
}
